export const TABLE_ACTION_BUTTONS_CLASSNAME = 'flex gap-2 justify-end pr-2'
